module.exports = __webpack_public_path__ + "img/fi_eye_blue.ff6508f2.svg";